<template>
  <div class="elevation-1">
    <create-checklist :typology="typology" v-on:checklist-created="addChecklist($event)">
    </create-checklist>

    <v-layout row wrap>
      <v-flex xs12>
        <v-expansion-panel popout>
          <v-expansion-panel-content v-for="(checklist, index) in typology.checklists" :key="checklist.id">
            <div slot="header">
              {{ checklist.application_type.name }} - {{ checklist.document_types.length }}
            </div>
            <v-card>

              <add-document-type-to-checklist :checklist="checklist"
                v-on:document-type-added="addDocumentType($event, index)">
              </add-document-type-to-checklist>

              <v-layout row wrap justify-center="true" pb-4>
                <v-flex v-if="checklist.document_types.length > 0" xs11>
                  <table class="v-table v-datatable elevation-5 theme--light" hide-actions>
                    <thead>
                      <tr>
                        <th scope="col" v-for="element in headersDocumentType" :key="element.text" :align="element.align">
                          {{ element.text }}
                        </th>
                      </tr>
                    </thead>
                    <draggable v-model="checklist.document_types" tag="tbody" class="draggable" ghost-class="ghost"
                      @end="updatePosition(checklist.document_types, checklist.id)">
                      <tr v-for="element in checklist.document_types" :key="element.id">
                        <td scope="row" class="text-xs-center">{{ element.id }}</td>
                        <td class="text-xs-center">{{ element.document_type_code }}</td>
                        <td class="text-xs-center">{{ element.document_type_name }}</td>
                        <td class="text-xs-center">{{ element.document_status }}</td>
                        <td class="text-xs-center">
                          <remove-document-type-from-checklist :item="element" :typology="typology"
                            :checklist-index="index" />
                        </td>
                      </tr>
                    </draggable>
                  </table>
                </v-flex>
                <v-flex v-else xs11>
                  <v-card class="text-xs-center">
                    Não possui documentos informados
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-flex>
    </v-layout>

  </div>
</template>

<script>
import CreateChecklist from '@/components/configurations/typology/show/checklist/create_checklist/CreateChecklist';
import AddDocumentTypeToChecklist from '@/components/configurations/typology/show/checklist/add_document_to_checklist/AddDocumentTypeToChecklist';
import RemoveDocumentTypeFromChecklist from '@/components/configurations/typology/show/checklist/remove_document_type_from_checklist/RemoveDocumentTypeFromChecklist';
import ApplicationTypeService from '@/services/applications/configurations/ApplicationTypeService';

import draggable from 'vuedraggable';
import ChecklistService from '@/services/applications/configurations/ChecklistService';

export default {
  name: 'ChecklistComponent',
  mounted() {
    const vm = this;
    ApplicationTypeService
      .fetchApplicationTypes()
      .then((response) => {
        vm.applicationTypes = response;
      });
  },
  props: ['typology'],
  components: {
    CreateChecklist,
    AddDocumentTypeToChecklist,
    RemoveDocumentTypeFromChecklist,
    draggable,
  },
  data() {
    return {
      headersDocumentType: [
        { text: 'ID', value: 'id', align: 'center' },
        { text: 'Código', value: 'code', align: 'center' },
        { text: 'Tipo de Documento', value: 'document_type', align: 'center' },
        { text: 'Status', value: 'status', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center' }],
      applicationTypes: [],
    };
  },
  methods: {
    addDocumentType(newChecklist, index) {
      this.$set(this.typology.checklists, index, newChecklist);
    },
    addChecklist(event) {
      this.typology.checklists.push(event);
    },
    updatePosition(checklist, id) {
      const list = checklist.map((item) => { return item.id });
      ChecklistService.sortDocumentType(list, id);
    }
  },
};
</script>

<style scoped lang="scss">
.draggable tr:hover {
  cursor: move;
}

.ghost {
  opacity: 0.5;
  background: #b3d4fc;
}
</style>
